// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"MoobileTooltip__Wrapper__2senj","Content":"MoobileTooltip__Content__362dj","ButtonSection":"MoobileTooltip__ButtonSection__28aRs","Link":"MoobileTooltip__Link__2Nf31"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileTooltip/MoobileTooltip.css
// module id = 178
// module chunks = 0